// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__13guB","tab":"Tabs_tab__3uEgX","tabActive":"Tabs_tabActive__1Nxyl"};